import { jsx as t } from "react/jsx-runtime";
import { CropperModal as c } from "./index2.js";
import { useCropperModalStore as o } from "./index9.js";
const i = () => {
  const { isOpen: e, modalProps: r, closeCropper: p } = o();
  return t(c, { isOpen: e, src: r == null ? void 0 : r.src, aspectRatio: r == null ? void 0 : r.aspect, onSuccess: r == null ? void 0 : r.onSuccess, onClose: p });
}, u = () => {
  const { openCropper: e } = o();
  return e;
};
export {
  i as CropperContainer,
  u as useCropper
};
